import { createAction } from "redux-actions";

const GET_SPONSORS_DASHBOARD = "GET_SPONSORS_DASHBOARD"
const UPDATE_SPONSORS_DASHBOARD = "UPDATE_SPONSORS_DASHBOARD"
const DELETE_SPONSORS_DASHBOARD = "DELETE_SPONSORS_DASHBOARD"
const SET_SPONSORS_DASHBOARD = "SET_SPONSORS_DASHBOARD"
const ADD_SPONSORS_DASHBOARD = "ADD_SPONSORS_DASHBOARD"
const DOWNLOAD_USERS_SPONSORS_DASHBOARD = "DOWNLOAD_USERS_SPONSORS_DASHBOARD"
const SET_SPONSORS_DASHBOARDSEGMENT = "SET_SPONSORS_DASHBOARDSEGMENT";
const GET_SPONSORS_DASHBOARD_CASES = "GET_SPONSORS_DASHBOARD_CASES";
// const BATCH_WRITE = "BATCH_WRITE"

export const constants = {
    GET_SPONSORS_DASHBOARD,
    UPDATE_SPONSORS_DASHBOARD,
    DELETE_SPONSORS_DASHBOARD,
    SET_SPONSORS_DASHBOARD,
    DOWNLOAD_USERS_SPONSORS_DASHBOARD,
    ADD_SPONSORS_DASHBOARD,
    SET_SPONSORS_DASHBOARDSEGMENT,
    GET_SPONSORS_DASHBOARD_CASES,
    // BATCH_WRITE
};

// ------------------------------------
// Actions
// ------------------------------------
export const getSponsorsDashboard = createAction(GET_SPONSORS_DASHBOARD, (data,callback) => ({
    data,callback
}))

export const getSponsorsDashboardCases = createAction(GET_SPONSORS_DASHBOARD_CASES, (data,callback) => ({
    data,callback
}))

export const addSponsorsDashboard = createAction(ADD_SPONSORS_DASHBOARD, (data, callback) => ({
    data, callback
}))

export const updateSponsorsDashboard = createAction(UPDATE_SPONSORS_DASHBOARD, (data, callback) => ({
    data, callback
}))

export const deleteSponsorsDashboard = createAction(DELETE_SPONSORS_DASHBOARD, (id, callback) => ({
    id, callback
}))

export const setSponsorsDashboard = createAction(SET_SPONSORS_DASHBOARD, (sponsors) => ({
    sponsors
}))
export const setSponsorsDashboardSegment = createAction(SET_SPONSORS_DASHBOARDSEGMENT, (sponsors) => ({
    sponsors
}))

export const downloadSponsorsDashboard = createAction(DOWNLOAD_USERS_SPONSORS_DASHBOARD, (callback) => ({
    callback
}))

// export const batchWrite = createAction(BATCH_WRITE, (resources, id, callback) => ({
//     resources,
//     id,
//     callback
// }))

export const actions = {
    getSponsorsDashboard,
    updateSponsorsDashboard,
    deleteSponsorsDashboard,
    setSponsorsDashboard,
    downloadSponsorsDashboard,
    addSponsorsDashboard,
    setSponsorsDashboardSegment,
    getSponsorsDashboardCases,
    // batchWrite
};
